export class ConfigNotFoundException extends Error {
  constructor(message?: string) {
    super(message ?? 'Configuration not found');
    this.name = 'ConfigNotFoundException';
  }
}
